var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6052_811)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.375H24",
    stroke: "#2CA6A4",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75H24",
    stroke: "#2CA6A4",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 9.9375L15.5625 21.1875",
    stroke: "#2CA6A4",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6052_811",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H48V48H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6052_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 1.40625C10.6086 1.40625 4.21875 7.79607 4.21875 15.5625C4.21875 18.7269 5.30212 21.6155 7.06612 23.9651L1.40625 29.625H18.375C26.1414 29.625 32.4375 23.3289 32.4375 15.5625C32.4375 7.79607 26.1414 1.40625 18.375 1.40625Z",
    stroke: "#2CA6A4",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1099 18.5938C38.6913 19.7673 43.7812 25.5189 43.7812 32.4375C43.7812 35.6018 42.6979 38.5841 40.934 40.9339L46.5937 46.5938H29.625C21.8586 46.5938 15.5625 40.2039 15.5625 32.4375C15.5625 31.4743 15.6593 30.5337 15.8438 29.625",
    stroke: "#2CA6A4",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6052_811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.061daacd7e727598c9fddc73a2b8fbfe.svg";
export { ForwardRef as ReactComponent };